var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pick date") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dateicon",
    transform: "translate(-11.000000, -11.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(13.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.17 C-0.646173183,25.17 -1.17000005,24.6461732 -1.17000005,24 L-1.17000005,2 C-1.17000005,1.35382682 -0.646173183,0.829999954 0,0.829999954 L24,0.829999954 C24.6461732,0.829999954 25.17,1.35382682 25.17,2 L25.17,24 C25.17,24.6461732 24.6461732,25.17 24,25.17 L0,25.17 Z M1.17000005,22.83 L22.83,22.83 L22.83,3.17000005 L1.17000005,3.17000005 L1.17000005,22.83 Z",
    id: "Stroke-1020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,8.82999995 C24.6461732,8.82999995 25.17,9.35382682 25.17,10 C25.17,10.6461732 24.6461732,11.17 24,11.17 L0,11.17 C-0.646173183,11.17 -1.17000005,10.6461732 -1.17000005,10 C-1.17000005,9.35382682 -0.646173183,8.82999995 0,8.82999995 L24,8.82999995 Z",
    id: "Stroke-1021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82999995,0 C3.82999995,-0.646173183 4.35382682,-1.17000005 5,-1.17000005 C5.64617318,-1.17000005 6.17000005,-0.646173183 6.17000005,0 L6.17000005,4 C6.17000005,4.64617318 5.64617318,5.17000005 5,5.17000005 C4.35382682,5.17000005 3.82999995,4.64617318 3.82999995,4 L3.82999995,0 Z",
    id: "Stroke-1022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.83,0 C10.83,-0.646173183 11.3538268,-1.17000005 12,-1.17000005 C12.6461732,-1.17000005 13.17,-0.646173183 13.17,0 L13.17,4 C13.17,4.64617318 12.6461732,5.17000005 12,5.17000005 C11.3538268,5.17000005 10.83,4.64617318 10.83,4 L10.83,0 Z",
    id: "Stroke-1023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.83,0 C17.83,-0.646173183 18.3538268,-1.17000005 19,-1.17000005 C19.6461732,-1.17000005 20.17,-0.646173183 20.17,0 L20.17,4 C20.17,4.64617318 19.6461732,5.17000005 19,5.17000005 C18.3538268,5.17000005 17.83,4.64617318 17.83,4 L17.83,0 Z",
    id: "Stroke-1024"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.169bd9a9c172cb10e099a611da5e5ccb.svg";
export { ForwardRef as ReactComponent };